export const MODAL_TYPES = {
  ENTER_PIN: 'ENTER_PIN',
  INFO: 'INFO',
  CONFIRM: 'CONFIRM',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  PACKAGE: 'PACKAGE',
  NOTIFICATION: 'NOTIFICATION',
  PENDING: 'PENDING',
  PHONE: 'PHONE',
  PORTMONE: 'PORTMONE',
  LIFECELL_PAYMENT: 'LIFECELL_PAYMENT',
};
